// @flow
import { Flex, Typography } from '@duxton-web/ui';
import { resetAllState } from 'actions/helpers';
import i18n from 'i18n-js';
import React, { useEffect } from 'react';
import DocumentTitle from 'react-document-title';
import { useDispatch, useSelector } from 'react-redux';

import { dispatchSuccessfulGoogleLogin } from 'omega-rtc/actions/user';
import ProgressiveContainer from 'omega-rtc/components/container/ProgressiveContainer';
import ConcedoLoginButton from 'omega-rtc/components/custom/ConcedoLoginButton';
import { GoogleForm } from 'omega-rtc/views/login/GoogleForm';
import './LoginPage.scss';

export function LoginPage({
  location,
  history,
}) {
  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state) => state.app.isLoggedIn);
  const grabLoginRequest = useSelector((state) => state.requests.grabLoginRequest || {});

  useEffect(() => {
    dispatch(resetAllState());
  }, []);

  const isGoogleLogin = () => {
    return window.Grab.config.AUTH_TYPE === 'google';
  };

  return (
    <ProgressiveContainer
      isLoading={grabLoginRequest.isPending}
      message={i18n.t('loader.log_in')}
    >
      <DocumentTitle title={i18n.t('login_page.title')}>
        <div className="login-dimmer">
          <Flex
            className="login-page"
          >
            <Typography.Title
              level={3}
              style={{
                fontWeight: 300,
                fontFamily: 'Roboto,Helvetica Neue,Arial,Helvetica,sans-serif',
              }}
            >
              Omega
            </Typography.Title>
            <div className="subtitle">{`Version ${window.Grab.config.APP_VERSION}`}</div>
            {isGoogleLogin() ? (
              <GoogleForm
                handleSuccessfulLogin={(jwt) => dispatch(dispatchSuccessfulGoogleLogin(jwt))}
              />
            ) : (
              <ConcedoLoginButton
                clientId={window.Grab.config.CONCEDO_CLIENT_ID}
                authBaseUrl={window.Grab.config.CONCEDO_AUTHN_URI}
                authPath={window.Grab.config.CONCEDO_AUTHN_PATH}
                buttonText="Login with Concedo"
                location={location}
                history={history}
                shouldLogin={
                  !grabLoginRequest.isPending &&
                  !grabLoginRequest.isSuccess &&
                  !isLoggedIn
                }
              />
            )}
          </Flex>
        </div>
      </DocumentTitle>
    </ProgressiveContainer>
  );
}

export default LoginPage;
